export type StripeKycRequirementGroup = 'form' | 'embedded' | 'support' | 'bank_account'

const stripeFieldLabels: Readonly<Record<string, string>> = {
  'individual.first_name': 'Primeiro nome',
  'individual.last_name': 'Sobrenome',
  'individual.email': 'E-mail',
  'individual.phone': 'Telefone',
  'individual.dob.day': 'Dia de nascimento',
  'individual.dob.month': 'Mês de nascimento',
  'individual.dob.year': 'Ano de nascimento',
  'individual.address.line1': 'Endereço',
  'individual.address.line2': 'Complemento',
  'individual.address.city': 'Cidade',
  'individual.address.state': 'Estado',
  'individual.address.postal_code': 'CEP',
  'individual.address.country': 'País do endereço',
  'company.name': 'Razão social',
  'company.tax_id': 'CNPJ',
  'company.address.line1': 'Endereço',
  'company.address.line2': 'Complemento',
  'company.address.city': 'Cidade',
  'company.address.state': 'Estado',
  'company.address.postal_code': 'CEP',
  'company.address.country': 'País do endereço',
  'business_profile.name': 'Nome fantasia',
  'business_profile.url': 'Site',
  'business_profile.mcc': 'MCC',
  'business_profile.product_description': 'Produto ou serviço',
  'company.owners_provided': 'Sócios da empresa',
  'tos_acceptance.date': 'Aceite dos termos',
  'tos_acceptance.ip': 'IP do aceite dos termos',
}

export function stripeFieldLabel(
  path: string,
  group?: StripeKycRequirementGroup,
): string | undefined {
  const knownLabel = stripeFieldLabels[path]
  if (knownLabel) return knownLabel
  if (path === 'company.verification.document') return 'Documento da empresa'
  if (/\.verification\.document$/.test(path)) return 'Documento de identificação'
  if (/^owners\./.test(path)) return 'Sócios da empresa'
  if (/^person_[^.]+(?:\..+)?$/.test(path)) {
    return group === 'form' ? 'Representante legal' : 'Pessoa relacionada à verificação'
  }
  return undefined
}
